import { createTheme } from '@material-ui/core/styles';

export const ADMIN_THEME_COOKIE = 'ouro-admin-theme';
export const DEFAULT_THEME_MODE = 'light';

export function createAppTheme(mode = DEFAULT_THEME_MODE) {
  const safeMode = mode === 'dark' ? 'dark' : 'light';

  const isDark = safeMode === 'dark';

  return createTheme({
    direction: 'ltr',
    typography: {
      useNextVariants: true,
    },
    palette: {
      type: safeMode,
      primary: {
        light: '#ff9a3a',
        main: '#FF7500',
        dark: '#e86d02',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: isDark ? '#fff' : '#000',
      },
      background: isDark
        ? {
            default: '#0b0f19',
            paper: '#111827',
          }
        : {
            default: '#f3f4f6',
            paper: '#ffffff',
          },
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            backgroundColor: isDark ? '#0b0f19' : '#f3f4f6',
            color: isDark ? '#f9fafb' : '#111827',
          },
        },
      },
    },
  });
}

const theme = createAppTheme(DEFAULT_THEME_MODE);
export default theme;
